import { Spin, Empty } from "antd";

import LogsTable from "@/components/tables/LogsTable";

// Страница системных логов
const HistoryTab = ({
  data = [],
  pending,
  pagination,
  onTableChange,
}) => {

  return (
    <>
      {pending ? (
        <div className="spin">
          <Spin size="large" />
        </div>
      ) : !!data.length ? (
        <LogsTable
          pagination={pagination}
          data={data}
          loading={pending}
          onChange={onTableChange}
        />
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
    </>
  );
};

export default HistoryTab;
